// "use client";

// import Image from "next/image";
// import Link from "next/link";
// import IconLeftCaret from "@/components/icons/icon-left-caret";
// import IconMinus from "@/components/icons/icon-minus";
// import IconAddition from "@/components/icons/icon-adition";
// import IconBin from "@/components/icons/icon-bin";
// import { useCart } from "@/lib/cart/useCart";

// export default function CartPage() {
//   const {
//     lines,
//     setQty,
//     remove,
//     toggle,
//     selectAll,
//     subtotal,
//     vat,
//     delivery,
//     total,
//     selectedCount,
//   } = useCart();

//   const allSelected = lines.length > 0 && lines.every((l) => l.selected);

//   return (
//     <main>
//       <section className="py-[100px] sm:py-[200px] xl:py-[150px]">
//         <div className="max-w-[calc(1280px+40px)] w-full mx-auto px-5">
//           <Link href="/menu" className="back_btn">
//             <IconLeftCaret className="max-sm:w-[4.22px]" />
//             Back
//           </Link>

//           <div className="text-center">
//             <h1 className="text-[25px] sm:text-[33px] md:text-4xl 2xl:text-[45px] md:mb-5 sm:mb-2 text-old-lace font-young-serif">
//               What’s on the Table?
//             </h1>
//             <p className="text-sm sm:text-base md:text-lg xl:text-xl 2xl:text-[22px] text-old-lace">
//               Check your delicious picks and get ready to feast.
//             </p>
//           </div>

//           <div className="w-full flex flex-col xl:flex-row gap-2.5 md:gap-5 mt-8 md:mt-[52px]">
//             <div className="grow space-y-1.25">
//               <div className="h-[53px] text-[10px] sm:text-base px-3 md:px-6 bg-pickled-bluewood rounded-[4.81px] md:rounded-[10px] center justify-between">
//                 <button
//                   onClick={() => selectAll(!allSelected)}
//                   className="underline"
//                 >
//                   {allSelected
//                     ? "Unselect all"
//                     : `Select All ${lines.length} item(s)`}
//                 </button>
//                 {selectedCount > 0 && (
//                   <span className="opacity-80">{selectedCount} selected</span>
//                 )}
//               </div>

//               {lines.length === 0 ? (
//                 <div className="p-8 text-center text-white/70 bg-pickled-bluewood rounded-[10px]">
//                   Cart is empty.{" "}
//                   <Link className="underline" href="/menu">
//                     Browse menu
//                   </Link>
//                 </div>
//               ) : (
//                 lines.map((item) => (
//                   <div
//                     key={item.id}
//                     className="w-full py-2.5 px-3 md:px-6 bg-pickled-bluewood rounded-[4.81px] md:rounded-[10px] flex items-center justify-between gap-2"
//                   >
//                     {/* select */}
//                     <input
//                       type="checkbox"
//                       checked={item.selected}
//                       onChange={(e) => toggle(item.id, e.target.checked)}
//                       className="scale-110 accent-old-gold"
//                       aria-label="select item"
//                     />

//                     {/* product info */}
//                     <div className="flex items-center gap-2 md:gap-4 min-w-0">
//                       <div className="w-[45.7px] md:w-[95px] h-[51.47px] md:h-[107px] rounded overflow-hidden shrink-0">
//                         <Image
//                           src={item.imageUrl || "/imgs/cart-1.png"}
//                           alt={item.name}
//                           width={100}
//                           height={100}
//                           className="size-full object-cover"
//                         />
//                       </div>
//                       <div className="truncate">
//                         <h3 className="item_name truncate">{item.name}</h3>
//                         <h4 className="flex items-center gap-2 text-[7.7px] sm:text-base font-light">
//                           ৳ {item.price.toFixed(2)}
//                         </h4>
//                       </div>
//                     </div>

//                     {/* line total */}
//                     <h4 className="flex items-center gap-2 text-[10.58px] md:text-xl lg:text-[22px] font-medium whitespace-nowrap">
//                       ৳ {(item.price * item.quantity).toFixed(2)}
//                     </h4>

//                     {/* quantity */}
//                     <div className="flex items-center gap-2 md:gap-4">
//                       <button
//                         className="quantity_btn cart_btn_gradient"
//                         onClick={() =>
//                           setQty(item.id, Math.max(1, item.quantity - 1))
//                         }
//                       >
//                         <IconMinus className="max-md:w-[7.91px]" />
//                       </button>
//                       <h4 className="text-[12.03px] sm:text-base min-w-[2ch] text-center">
//                         {item.quantity}
//                       </h4>
//                       <button
//                         className="quantity_btn cart_btn_gradient"
//                         onClick={() => setQty(item.id, item.quantity + 1)}
//                       >
//                         <IconAddition className="max-md:w-[7.91px]" />
//                       </button>
//                     </div>

//                     {/* actions */}
//                     <div className="flex items-center gap-2 md:gap-4">
//                       <button
//                         onClick={() => remove(item.id)}
//                         aria-label="Remove"
//                       >
//                         <IconBin className="max-md:w-[10px]" />
//                       </button>
//                     </div>
//                   </div>
//                 ))
//               )}
//             </div>

//             {/* summary */}
//             <div className="xl:max-w-[414px] w-full">
//               <div className="w-full p-5 bg-pickled-bluewood rounded-[10px]">
//                 <h1 className="text-sm md:text-[22px] font-semibold">
//                   Order Summary
//                 </h1>
//                 <div className="w-full h-[1px] bg-[#FDF2DE]/60 my-3.5 md:my-8" />

//                 <div className="space-y-3 md:space-y-4">
//                   <Row
//                     label={`Subtotal (${selectedCount} item${
//                       selectedCount !== 1 ? "s" : ""
//                     })`}
//                     value={subtotal}
//                   />
//                   <Row label="Delivery fee" value={delivery()} />
//                   <Row label="VAT (5%)" value={vat()} />
//                 </div>

//                 <div className="w-full h-[1px] bg-[#FDF2DE]/60 my-3.5 md:my-8" />
//                 <Row label="TOTAL" value={total()} strong />
//               </div>

//               <div className="mt-3 md:mt-6">
//                 <Link href="/place-order">
//                   <button
//                     className="cart_btn_gradient w-full h-[29px] md:h-[67px] text-[10px] md:text-[22px] font-medium bg-old-gold rounded-[6.55px] md:rounded-[15px]"
//                     disabled={selectedCount === 0}
//                   >
//                     Checkout
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// }

// function Row({
//   label,
//   value,
//   strong = false,
// }: {
//   label: string;
//   value: number;
//   strong?: boolean;
// }) {
//   return (
//     <div className="flex items-center justify-between">
//       <h4
//         className={`text-xs md:text-lg text-white ${
//           strong ? "font-semibold" : ""
//         }`}
//       >
//         {label}
//       </h4>
//       <p
//         className={`text-xs md:text-lg ${strong ? "font-bold" : "font-medium"}`}
//       >
//         ৳ {value.toFixed(2)}
//       </p>
//     </div>
//   );
// }
"use client";

import Image from "next/image";
import Link from "next/link";
import IconLeftCaret from "@/components/icons/icon-left-caret";
import IconMinus from "@/components/icons/icon-minus";
import IconAddition from "@/components/icons/icon-adition";
import IconBin from "@/components/icons/icon-bin";
import { useCart, DELIVERY_ZONES } from "@/lib/cart/useCart";

export default function CartPage() {
  const {
    lines,
    setQty,
    remove,
    toggle,
    selectAll,
    subtotal,
    vat,
    delivery,
    total,
    selectedCount,
    zone,
    setZone,
    isDeliveryAvailable,
  } = useCart();

  const allSelected = lines.length > 0 && lines.every((l) => l.selected);

  return (
    <main>
      <section className="py-[100px] sm:py-[200px] xl:py-[150px]">
        <div className="max-w-[calc(1280px+40px)] w-full mx-auto px-5">
          <Link href="/menu" className="back_btn">
            <IconLeftCaret className="max-sm:w-[4.22px]" />
            Back
          </Link>

          <div className="text-center">
            <h1 className="text-[25px] sm:text-[33px] md:text-4xl 2xl:text-[45px] md:mb-5 sm:mb-2 text-old-lace font-young-serif">
              What's on the Table?
            </h1>
            <p className="text-sm sm:text-base md:text-lg xl:text-xl 2xl:text-[22px] text-old-lace">
              Check your delicious picks and get ready to feast.
            </p>
          </div>

          <div className="w-full flex flex-col xl:flex-row gap-2.5 md:gap-5 mt-8 md:mt-[52px]">
            <div className="grow space-y-1.25">
              <div className="h-[53px] text-[10px] sm:text-base px-3 md:px-6 bg-pickled-bluewood rounded-[4.81px] md:rounded-[10px] center justify-between">
                <button
                  onClick={() => selectAll(!allSelected)}
                  className="underline"
                >
                  {allSelected
                    ? "Unselect all"
                    : `Select All ${lines.length} item(s)`}
                </button>
                {selectedCount > 0 && (
                  <span className="opacity-80">{selectedCount} selected</span>
                )}
              </div>

              {lines.length === 0 ? (
                <div className="p-8 text-center text-white/70 bg-pickled-bluewood rounded-[10px]">
                  Cart is empty.{" "}
                  <Link className="underline" href="/menu">
                    Browse menu
                  </Link>
                </div>
              ) : (
                lines.map((item) => (
                  <div
                    key={item.id}
                    className="w-full py-2.5 px-3 md:px-6 bg-pickled-bluewood rounded-[4.81px] md:rounded-[10px] flex items-center justify-between gap-2"
                  >
                    <input
                      type="checkbox"
                      checked={item.selected}
                      onChange={(e) => toggle(item.id, e.target.checked)}
                      className="scale-110 accent-old-gold"
                      aria-label="select item"
                    />
                    <div className="flex items-center gap-2 md:gap-4 min-w-0">
                      <div className="w-[45.7px] md:w-[95px] h-[51.47px] md:h-[107px] rounded overflow-hidden shrink-0">
                        <Image
                          src={item.imageUrl || "/imgs/cart-1.png"}
                          alt={item.name}
                          width={100}
                          height={100}
                          className="size-full object-cover"
                        />
                      </div>
                      <div className="truncate">
                        <h3 className="item_name truncate">{item.name}</h3>
                        <h4 className="flex items-center gap-2 text-[7.7px] sm:text-base font-light">
                          ৳ {item.price.toFixed(2)}
                        </h4>
                      </div>
                    </div>
                    <h4 className="flex items-center gap-2 text-[10.58px] md:text-xl lg:text-[22px] font-medium whitespace-nowrap">
                      ৳ {(item.price * item.quantity).toFixed(2)}
                    </h4>
                    <div className="flex items-center gap-2 md:gap-4">
                      <button
                        className="quantity_btn cart_btn_gradient"
                        onClick={() =>
                          setQty(item.id, Math.max(1, item.quantity - 1))
                        }
                      >
                        <IconMinus className="max-md:w-[7.91px]" />
                      </button>
                      <h4 className="text-[12.03px] sm:text-base min-w-[2ch] text-center">
                        {item.quantity}
                      </h4>
                      <button
                        className="quantity_btn cart_btn_gradient"
                        onClick={() => setQty(item.id, item.quantity + 1)}
                      >
                        <IconAddition className="max-md:w-[7.91px]" />
                      </button>
                    </div>
                    <div className="flex items-center gap-2 md:gap-4">
                      <button
                        onClick={() => remove(item.id)}
                        aria-label="Remove"
                      >
                        <IconBin className="max-md:w-[10px]" />
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>

            {/* summary */}
            <div className="xl:max-w-[414px] w-full">
              <div className="w-full p-5 bg-pickled-bluewood rounded-[10px]">
                <h1 className="text-sm md:text-[22px] font-semibold">
                  Order Summary
                </h1>
                <div className="w-full h-[1px] bg-[#FDF2DE]/60 my-3.5 md:my-8" />

                {/* Zone selector */}
                <div className="mb-4">
                  <label className="block text-xs md:text-sm text-white/80 mb-1.5">
                    Delivery Area
                  </label>
                  <select
                    value={zone}
                    onChange={(e) => setZone(e.target.value as any)}
                    className="w-full bg-[#1e2d3d] border border-white/20 text-white text-xs md:text-sm rounded-[8px] px-3 py-2.5 focus:outline-none focus:border-old-gold"
                  >
                    <option value="" disabled>
                      Select your area…
                    </option>
                    {DELIVERY_ZONES.map((z) => (
                      <option
                        key={z.value}
                        value={z.value}
                        disabled={z.fee === null}
                      >
                        {z.label}
                        {z.fee !== null ? ` — ৳${z.fee}` : " — Not available"}
                      </option>
                    ))}
                  </select>

                  {zone === "outside_dhaka" && (
                    <p className="mt-2 text-xs text-red-400">
                      Sorry, we don't deliver outside Dhaka.
                    </p>
                  )}
                </div>

                <div className="space-y-3 md:space-y-4">
                  <Row
                    label={`Subtotal (${selectedCount} item${selectedCount !== 1 ? "s" : ""})`}
                    value={subtotal}
                  />
                  <Row label="Delivery fee" value={delivery()} />
                  <Row label="VAT (5%)" value={vat()} />
                </div>

                <div className="w-full h-[1px] bg-[#FDF2DE]/60 my-3.5 md:my-8" />
                <Row label="TOTAL" value={total()} strong />
              </div>

              <div className="mt-3 md:mt-6">
                <Link
                  href={
                    isDeliveryAvailable && zone && selectedCount > 0
                      ? "/place-order"
                      : "#"
                  }
                >
                  <button
                    className="cart_btn_gradient w-full h-[29px] md:h-[67px] text-[10px] md:text-[22px] font-medium bg-old-gold rounded-[6.55px] md:rounded-[15px] disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={
                      selectedCount === 0 || !zone || !isDeliveryAvailable
                    }
                  >
                    Checkout
                  </button>
                </Link>
                {!zone && selectedCount > 0 && (
                  <p className="text-center text-xs text-white/60 mt-2">
                    Please select a delivery area first.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

function Row({
  label,
  value,
  strong = false,
}: {
  label: string;
  value: number;
  strong?: boolean;
}) {
  return (
    <div className="flex items-center justify-between">
      <h4
        className={`text-xs md:text-lg text-white ${strong ? "font-semibold" : ""}`}
      >
        {label}
      </h4>
      <p
        className={`text-xs md:text-lg ${strong ? "font-bold" : "font-medium"}`}
      >
        ৳ {value.toFixed(2)}
      </p>
    </div>
  );
}
